export default function InviteBanner({ invites, onAccept, onDecline }) {
  if (!invites || invites.length === 0) return null;

  return (
    <div className="invite-banner-list">
      {invites.map(inv => (
        <div key={inv.id} className="invite-banner">
          <div className="invite-banner-text">
            <strong>{inv.fromName}</strong> invited you to play!
          </div>
          <div className="invite-banner-code">Game: {inv.gameCode}</div>
          <div className="invite-banner-actions">
            <button className="invite-accept-btn" onClick={() => onAccept(inv)}>Join</button>
            <button className="invite-decline-btn" onClick={() => onDecline(inv.id)}>Dismiss</button>
          </div>
        </div>
      ))}
    </div>
  );
}
